import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["href"];
var _hoisted_2 = {
  size: "md",
  class: "rounded-button"
};
var _hoisted_3 = {
  class: "button-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("a", {
    href: $props.link,
    class: "side-modal-button-wrapper"
  }, [_createElementVNode("button", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("path", {
    d: "M21.5 21.5H2.5V11.5001L11.75 1.5L21.5 11.5001V21.5Z",
    "stroke-width": "1.4",
    "stroke-miterlimit": "10",
    "stroke-linecap": "square",
    "stroke-linejoin": "round"
  }), _createElementVNode("path", {
    d: "M14 15H10V21.5H14V15Z",
    "stroke-width": "1.4",
    "stroke-miterlimit": "10",
    "stroke-linecap": "square",
    "stroke-linejoin": "round"
  })], -1 /* CACHED */)), _createElementVNode("span", _hoisted_3, _toDisplayString($props.title || "Úvod"), 1 /* TEXT */)])], 8 /* PROPS */, _hoisted_1);
}